import {SxProps} from '@mui/material';
import theme from 'src/theme';

export const placeholderWrapperSx: SxProps = {
    position: 'relative',
    width: '100%',
};

/**
 * The margin a select carries when it sits under a form label.
 *
 * Toolbars do not want it, and for a long time each one cancelled it by hand - `marginTop: 16px` with
 * `marginBottom: -8px` in the sessions filters, `mb: -1` on the charger page. Compensating for a
 * margin instead of not having one is why the row realigned whenever a control changed height.
 */
export const containerSx: SxProps = {
    mt: 2,
    [theme.breakpoints.down('lg')]: {
        mt: 0.5,
    },
};

/** In a toolbar, where the control is level with its neighbours and nothing sits above it. */
export const denseContainerSx: SxProps = {
    m: 0,
};

export const placeholderSx: SxProps = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: theme.spacing(12 / 8, 14 / 8),
    color: theme.palette.neutral[300],
    display: 'flex',
    alignItems: 'center',
};

export const descriptionSx: SxProps = {
    fontSize: '0.75rem',
    color: theme.palette.neutral[600],
    py: 1,
};

export const optionBtnSx: SxProps = {
    width: '100%',
    p: 0,
    justifyContent: 'flex-start',
};
